export const ONECLUB_URL = {
  account: `${process.env.ONECLUB_URL}/admin/account`,
  manager: `${process.env.ONECLUB_URL}/admin/manager`,
  seller: `${process.env.ONECLUB_URL}/admin/seller`,
  privacy: `${process.env.ONECLUB_URL}/privacy?app=ow&noAppeal=1`,
  // 跳转钱包，需要注入国家码
  wallet: `${process.env.ONECLUB_URL}/admin/wallet`,
  /** kpc */
  owKyc: `${process.env.ONECLUB_URL}/ow/kycApply`,
  /** oneclub 服务申请 */
  serviceApply: `${process.env.ONECLUB_URL}/admin/serviceApply`,
  bill: `${process.env.ONECLUB_URL}/admin/billManagement/owBill`,
  freightBill: `${process.env.ONECLUB_URL}/admin/billManagement/freight-bill`,
}
